import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_DOCUMENT} from '../../constants';

export default {
  id: 'AJOUT_DOC',
  title: 'Come posso aggiungere un documento aggiuntivo?',
  description: '',
  categories: [CONTENT_CATEGORY_DOCUMENT],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    adornment: '1.',
    value: 'Dalla scheda «Documenti», fare clic in alto a destra su '
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_AJOUT_DOC/IT_AJOUT_DOC_1.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '2.',
    value: 'Poi su «Aggiungere un documento»'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_AJOUT_DOC/IT_AJOUT_DOC_2.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '3.',
    value: 'Selezionare o cercare il documento desiderato'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_AJOUT_DOC/IT_AJOUT_DOC_3.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '4.',
    value: 'Quindi fare clic su «Confermare»'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_AJOUT_DOC/IT_AJOUT_DOC_4.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Il documento viene aggiunto direttamente alla cartella. Devi solo scaricarlo.'
  }]
};
